import { getTripInformationValue } from '@src/common/utils/form/ValueGetters';
import type { Order } from '@src/orders/domain/Order';
import type { PermitApplication } from '@src/orders/domain/PermitApplication';
import {
  EffectiveDateField,
  TripBaseRegisteredWeightField,
  TripDestinationField,
  TripFinalDestinationField,
  TripIncludesReturnTripField,
  TripMileageField,
  TripOriginalOriginField,
  TripOriginField,
  TripReturnDestinationField,
  TripReturnMileageField,
  TripReturnRouteField,
  TripRouteField,
} from '@src/permitField/TripInformationFields';
import { CategorySection } from '@src/permits/CategorySection';
import { useTranslation } from 'react-i18next';

export const RoutingAndStatesCategory = ({
  permitApplication,
  order,
}: {
  permitApplication: PermitApplication;
  order: Order;
}) => {
  const { t } = useTranslation();
  const fields = permitApplication.getFieldsBySection('routingAndStates');
  if (fields.size === 0) return null;

  return (
    <CategorySection
      title={t('orderSections.routingAndStates')}
      requiredFields={Array.from(fields.values()).flat()}
      permitApplication={permitApplication}
      order={order}
      subsections={[
        {
          label: t('tripInformation'),
          valueGetter: (field, form) =>
            getTripInformationValue(field, form, permitApplication),
          fields: [
            TripOriginalOriginField.fieldName,
            TripFinalDestinationField.fieldName,
            TripOriginField.fieldName,
            TripDestinationField.fieldName,
            TripBaseRegisteredWeightField.fieldName,
            TripRouteField.fieldName,
            TripMileageField.fieldName,
            EffectiveDateField.fieldName,
            TripIncludesReturnTripField.fieldName,
            TripReturnDestinationField.fieldName,
            TripReturnRouteField.fieldName,
            TripReturnMileageField.fieldName,
          ],
        },
      ]}
    />
  );
};
